import { getLocale } from '../../utils/pathHelper';

type TranslationKeys =
'getCoupon'|
'timeRemaining'|
'countDown';

type TranslationLocales = 'en'|'ja'|'zh-CN'|'zh-HK'|'zh-TW';

export type ITranslation = {
  [key in TranslationKeys]: ({}?: { [arg: string]: string|number }) => string;
}

const locales: {
  [locale in TranslationLocales]: ITranslation
} = {
  'en': {
    getCoupon: ({ amount }) => (`Get a ${amount} yen off coupon!`),
    timeRemaining: () => 'Time Remaining',
    countDown: ({ d, h, m, s }) => `<b>${d}</b>d <b>${h}</b>h <b>${m}</b>m <b>${s}</b>s`,
  },
  'ja': {
    getCoupon: ({ amount }) => (`${amount}円OFFクーポンをGet!`),
    timeRemaining: () => 'Time Remaining',
    countDown: ({ d, h, m, s }) => `<b>${d}</b>日<b>${h}</b>時間<b>${m}</b>分<b>${s}</b>秒`,
  },
  'zh-CN': {
    getCoupon: ({ amount }) => ('xxx'),
    timeRemaining: () => '剩馀时间',
    countDown: ({ d, h, m, s }) => `<b>${d}</b>天<b>${h}</b>小时<b>${m}</b>分<b>${s}</b>秒`,
  },
  'zh-HK': {
    getCoupon: ({ amount }) => (`價值${amount}日圓優惠券拎到手！`),
    timeRemaining: () => '剩餘時間',
    countDown: ({ d, h, m, s }) => `<b>${d}</b>天<b>${h}</b>小時<b>${m}</b>分<b>${s}</b>秒`,
  },
  'zh-TW': {
    getCoupon: ({ amount }) => (`快來拿${amount}日圓優惠券！`),
    timeRemaining: () => '剩餘時間',
    countDown: ({ d, h, m, s }) => `<b>${d}</b>天<b>${h}</b>小時<b>${m}</b>分<b>${s}</b>秒`,
  },
};

const t: ITranslation = locales[getLocale() || 'en'];

export default t;
